export enum SIGN_IN_CORE {
    /**
     * @value Did not receive the email?
     */
    EMAIL_NOT_RECEIVED = 'EMAIL_NOT_RECEIVED',
    /**
     * @value We have sent a sign-in link to %EMAIL%
     * @description Sentence on the check-emails page telling the user where the sign-in link was sent. %EMAIL% is the address, or a generic fallback when the address is unknown.
     */
    LINK_SENT_TO_EMAIL = 'SIGN_IN.LINK_SENT_TO_EMAIL',
    /**
     * @value The link is valid for %MINUTES% minutes
     * @description Information text on the check-emails page, displayed under the sentence telling the user where the sign-in link was sent. %MINUTES% is the number of minutes the link stays valid.
     */
    LINK_VALIDITY_DURATION = 'SIGN_IN.LINK_VALIDITY_DURATION',
    /**
     * @value Sign in with %PROVIDER%
     */
    LOGIN_GENERIC_SIGN_IN = 'LOGIN.GENERIC_SIGN_IN',
    /**
     * @value Powered by
     */
    POWERED_BY = 'LOGIN_POWERED_BY',
    /**
     * @value Try another address
     */
    TRY_ANOTHER_ADDRESS = 'TRY_ANOTHER_ADDRESS',
    /**
     * @value your email address
     * @description Generic stand-in for the user's email address, used in the check-emails sentence when the frontend does not know the address the link was sent to.
     */
    YOUR_EMAIL_ADDRESS = 'SIGN_IN.YOUR_EMAIL_ADDRESS',
}
